import type { AppNavigationModule } from '@/config/appNavigation'
import type { TableSidebarItem } from '../api/contracts'

/** A table's address: `/tables/<id>`, then anything. */
const TABLE_PATH = /^\/tables\/([^/?#]+)/

/**
 * What a favorite points to, described, for its info mark: an app page's
 * menu description, or a table's own description. A view has none here, since
 * views aren't loaded for every table up front, and its table's would mislead.
 */
export function favoriteTargetDescription(
  path: string,
  isView: boolean,
  modules: readonly AppNavigationModule[],
  tables: readonly Pick<TableSidebarItem, 'id' | 'description'>[]
): string | null {
  for (const module of modules) {
    for (const section of module.sections) {
      const item = section.items.find((candidate) => candidate.to === path)
      if (item) return item.description ?? null
    }
  }
  if (isView) return null
  const tableId = TABLE_PATH.exec(path)?.[1]
  if (!tableId) return null
  return tables.find((table) => table.id === tableId)?.description ?? null
}
